/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  PriceChart actions index -- refer to nzr PriceChart module
 */

import { createAction } from 'redux-actions'
import {
  CLEAR_HOOD_PRICE_CHART_DATA,
  CLEAR_PRICE_CHART_DATA,
  DONE_FETCHING_CITY_PRICE_CHART_DATA,
  DONE_FETCHING_HOOD_PRICE_CHART_DATA,
  ERROR_FETCHING_CITY_PRICE_CHART_DATA,
  ERROR_FETCHING_HOOD_PRICE_CHART_DATA,
  SET_CITY_PRICE_CHART_DATA,
  SET_HOOD_PRICE_CHART_DATA,
  START_FETCHING_CITY_PRICE_CHART_DATA,
  START_FETCHING_HOOD_PRICE_CHART_DATA,
} from '../constants'

export interface SetPriceChartDataPayload {
  priceChartData: any
  key: string
}
export interface StartFetchingPayload {
  key: string
}

// fetching
export const doneFetchingCityPriceChartData = createAction(DONE_FETCHING_CITY_PRICE_CHART_DATA)
export const errorFetchingCityPriceChartData = createAction(ERROR_FETCHING_CITY_PRICE_CHART_DATA)
export const startFetchingCityPriceChartData = createAction<
  StartFetchingPayload,
  typeof START_FETCHING_CITY_PRICE_CHART_DATA
>(START_FETCHING_CITY_PRICE_CHART_DATA)

export const doneFetchingHoodPriceChartData = createAction(DONE_FETCHING_HOOD_PRICE_CHART_DATA)
export const errorFetchingHoodPriceChartData = createAction(ERROR_FETCHING_HOOD_PRICE_CHART_DATA)
export const startFetchingHoodPriceChartData = createAction<
  StartFetchingPayload,
  typeof START_FETCHING_HOOD_PRICE_CHART_DATA
>(START_FETCHING_HOOD_PRICE_CHART_DATA)

// storing
export const clearPriceChartData = createAction(CLEAR_PRICE_CHART_DATA)
export const clearHoodPriceChartData = createAction(CLEAR_HOOD_PRICE_CHART_DATA)
export const setCityPriceChartData = createAction<
  SetPriceChartDataPayload,
  typeof SET_CITY_PRICE_CHART_DATA
>(SET_CITY_PRICE_CHART_DATA)
export const setHoodPriceChartData = createAction<
  SetPriceChartDataPayload,
  typeof SET_HOOD_PRICE_CHART_DATA
>(SET_HOOD_PRICE_CHART_DATA)
